export default "__VITE_ASSET__629ad340__"